export type SameSite = "Lax" | "Strict" | "None";

function isBrowser() {
  return typeof document !== "undefined";
}

export function getCookie(name: string): string | null {
  if (!isBrowser()) return null;
  const parts = document.cookie ? document.cookie.split("; ") : [];
  for (const part of parts) {
    const eqIdx = part.indexOf("=");
    if (eqIdx === -1) continue;
    const key = part.slice(0, eqIdx);
    if (key !== name) continue;
    const raw = part.slice(eqIdx + 1);
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw;
    }
  }
  return null;
}

export function setCookie(
  name: string,
  value: string,
  opts?: { maxAgeDays?: number; path?: string; sameSite?: SameSite }
): void {
  if (!isBrowser()) return;
  const maxAgeDays = opts?.maxAgeDays ?? 30;
  const path = opts?.path ?? "/";
  const sameSite = opts?.sameSite ?? "Lax";
  const maxAgeSeconds = Math.max(0, Math.floor(maxAgeDays * 24 * 60 * 60));
  const secure =
    typeof window !== "undefined" && window.location.protocol === "https:";

  let cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAgeSeconds}; Path=${path}; SameSite=${sameSite}`;
  if (sameSite === "None" || secure) cookie += "; Secure";
  document.cookie = cookie;
}

export function deleteCookie(
  name: string,
  opts?: { path?: string; sameSite?: SameSite }
): void {
  if (!isBrowser()) return;
  const path = opts?.path ?? "/";
  const sameSite = opts?.sameSite ?? "Lax";
  const secure =
    typeof window !== "undefined" && window.location.protocol === "https:";

  let cookie = `${name}=; Max-Age=0; Path=${path}; SameSite=${sameSite}`;
  if (sameSite === "None" || secure) cookie += "; Secure";
  document.cookie = cookie;
}


